import React, { useEffect } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import TextButton from "../components/error/textButton";
import ErrorAnimation from "../components/error/lottieAnimation";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);
`;

export default function ErrorPage() {
  return (
    <Container>
      <Header></Header>
      <ErrorAnimation></ErrorAnimation>
      <TextButton></TextButton>
      <Footer></Footer>
    </Container>
  );
}
